import { Component, OnInit, ViewChild } from '@angular/core';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-contactuspage',
  templateUrl: './contactuspage.component.html',
  styleUrls: ['./contactuspage.component.css']
})
export class ContactuspageComponent implements OnInit {

  @ViewChild('name') FullName;
  @ViewChild('email') Email;
  @ViewChild('subject') Subject;
  @ViewChild('message') Message;

  ShowConfirmationMsg = false;
  ShowErrorMsg = false;

  constructor(public ds: DataService) { }

  ngOnInit() {
  }

  SendEmail() {
    if(this.FullName.nativeElement.value != undefined && this.Email.nativeElement.value != undefined && this.Message.nativeElement.value != undefined){
      this.ShowConfirmationMsg = true;  
      let object = {
        FullName: this.FullName.nativeElement.value,
        Email: this.Email.nativeElement.value,
        Subject: this.Subject.nativeElement.value,
        Message: this.Message.nativeElement.value,
      }

      this.ds.SendMessage(JSON.stringify(object)).then((res) => {
        this.Reset();
        setTimeout(() => {
          this.ShowConfirmationMsg = false;
        }, 3000);        
        console.log(res);
      }, (error) => {
        console.log(error);
      });
    }
    else {
      this.ShowErrorMsg = true;
      setTimeout(() => {
        this.ShowErrorMsg = false;
      }, 3000);
    }
  }

  Reset() {
    this.FullName.nativeElement.value = "";
    this.Email.nativeElement.value = "";
    this.Subject.nativeElement.value = "";
    this.Message.nativeElement.value = "";
  }

}
